import {
  TGetFavoriteEntitiesType,
  TFetchRemoveFavorite,
  TSuccessRemoveFavorite,
  TErrorRemoveFavorite,
} from '../../actions/favoriteEntities';
import { TRemoveAllFetch, TRemoveAllSuccess, TRemoveAllFail } from '../../actions/favoriteEntities/removeAll';

export const FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE: TGetFavoriteEntitiesType = 'favoriteEntities/status_changed';

export const FAVORITE_ENTITIES_FETCH_REMOVE_FAVORITE: TFetchRemoveFavorite = 'favoriteEntities/fetch_remove_favorite';
export const FAVORITE_ENTITIES_SUCCESS_REMOVE_FAVORITE: TSuccessRemoveFavorite =
  'favoriteEntities/success_remove_favorite';
export const FAVORITE_ENTITIES_ERROR_REMOVE_FAVORITE: TErrorRemoveFavorite = 'favoriteEntities/error_remove_favorite';

export const FAVORITE_ENTITIES_REMOVE_ALL_FETCH: TRemoveAllFetch = 'favoriteEntities/remove_all_fetch';
export const FAVORITE_ENTITIES_REMOVE_ALL_SUCCESS: TRemoveAllSuccess = 'favoriteEntities/remove_all_success';
export const FAVORITE_ENTITIES_REMOVE_ALL_FAIL: TRemoveAllFail = 'favoriteEntities/remove_all_fail';
